module.exports = __webpack_public_path__ + "img/kommune-1444.b42fb5dc.svg";